import { UAE_REDIRECT_ROUTE, isUaeBlockedRoute } from '~/utils/uae-gate-client/uaeGate';

// Hard refresh / direct visit to a pricing page: route middleware ran on the server without the session.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const route = useRoute();
    if (isUaeBlockedRoute(route.path) && useUaeGate().isUae.value) {
      void navigateTo(UAE_REDIRECT_ROUTE, { replace: true });
    }
  });
});
